import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';
import { ResponseData } from 'src/app/Model/Base/Response';
import { DocumentLegalModel } from 'src/app/Model/DocumentLegalModel.Model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestStatusLegalView } from 'src/app/Model/RequestStatusLegalView';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { RequestService } from 'src/app/Services/request/request.service';
import Swal from 'sweetalert2';

const ARRAY: any = [
  { DocumentLegalName: 'Otrosi', DocumentName: '', Status: false, Actions: 0, FileLink: '' },
];

@Component({
  selector: 'app-agency-legal',
  templateUrl: './agency-legal.component.html',
  styleUrls: ['./agency-legal.component.css']
})

export class AgencyLegalComponent implements OnInit {
  public IdRequest: number;
  fileOtroSi: File;
  fileAnexo: File;
  request: RequestModel = null;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  public requestcode: string;
  public displayedColumns: string[] = ['DocumentLegalName', 'DocumentName', 'Download', 'Upload'];
  public ConnectionDocumentsTraining: DocumentLegalModel[] = [];
  public dataSource: MatTableDataSource<DocumentLegalModel>;
  public data = ARRAY;
  public legalDocument: any;
  public AllowSignDocuments: boolean = false;

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly activeRoute: ActivatedRoute,
    private readonly RequestStatus: RequesStatusService,
    private readonly route: ActivatedRoute,
    private readonly requestService: RequestService,
    private readonly lsService : SessionStorageService
  ) { }

  async ngOnInit() {
    this.IdRequest = this.activeRoute.snapshot.params.id;
    await this.requestService.getRequestById(this.IdRequest)
      .then(async (res) => {
        this.request = res
        this.lsService.setLSItem('RequestCode', res.RequestCode)
        this.lsService.setLSItem('IdRequest', res.Id.toString())
        this.lsService.setLSItem('type', res.ConnectionType.toString())
      })
    this.getLegalDocumentsByRequest();
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getLegalDocumentsByRequest() {
    this.RequestStatus.getAgencyDocumentLegal(this.IdRequest).then(res => {
      this.legalDocument = res;
      this.data[0].DocumentName = this.legalDocument.FileName1;
      this.data[0].FileLink = this.legalDocument.FileLink1;
      this.data[0].Status = this.legalDocument.FileLink1 ? true : false;
    })
  }

  async onFileSelected(event) {
    await this.spinner.show();
    let size = event.target.files[0].size;
    if (size > 2097152) {
      this.resetFile();
      await this.spinner.hide();
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('ExtraWarranty.Message.Size')
      })
      return;
    }
    let type = event.target.files[0].type;
    if (type != 'application/pdf') {
      this.resetFile();
      await this.spinner.hide();
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('ExtraWarranty.Message.Extension')
      })
      return;
    }
    this.fileOtroSi = event.target.files[0];
    await this.spinner.hide();
  }

  async loadRequest() {
    await this.spinner.show();
    await this.requestService.getRequestById(this.IdRequest)
      .then(async (res) => {
        this.request = res
        this.lsService.setLSItem('RequestCode', res.RequestCode)
        this.lsService.setLSItem('IdRequest', res.Id.toString())
        this.lsService.setLSItem('type', res.ConnectionType.toString())
      })
    if (this.IdRequest != null) {
      await this.getLegalDocumentsByRequest();
    }
    await this.spinner.hide();
  }

  async uploadFiles() {
    let status = new RequestStatusLegalView();
    await this.spinner.show();
    if (this.fileAnexo) {
      await (await this.convertFile(this.fileAnexo)).subscribe(async base64 => {
        status.fileOficinas = base64
      });
    }
    if (this.fileOtroSi) {
      await (await this.convertFile(this.fileOtroSi)).subscribe(async base64 => {
        status.fileOtros = base64
      });
    }
    await this.spinner.hide();

    let res: ResponseData;
    status.Approve = true;
    status.IdComponent = 35;
    status.IdProfile = null;
    status.IdRequest = this.IdRequest;
    status.fileOtrosName = this.legalDocument.FileName1
    status.fileOficinasName =null

    await this.spinner.show();
    await this.RequestStatus.PostAgencyUploadLegalDocuments(status).then(resp => {
      res = resp;
    })
    await this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await this.RequestStatus.PutAgencyDocumentLegal(status)
      await this.loadRequest()
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: res.head.error.description,
        icon: 'error'
      }
      )
    }
  }

  async convertFile(file: File) {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }

  public DownloadFormat(url) {
    window.open(url, '_blank','noopener,noreferrer')
  }

  resetFile() {
    (<HTMLInputElement>document.getElementById('fileUpload')).value = "";
  }
}

